import {
  SESSION_ACTIVITY_EVENT,
  SESSION_EXPIRED_EVENT,
} from "../auth/sessionEvents";

export class ApiError extends Error {
  constructor({ status, title, detail, errors }) {
    super(detail || title || `Request failed with status ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.title = title;
    this.detail = detail;
    this.errors = errors;
  }
}

async function parseResponse(response) {
  if (response.ok) {
    if (response.status === 204) {
      return undefined;
    }

    return response.json();
  }

  let problem;
  try {
    problem = await response.json();
  } catch {
    problem = undefined;
  }

  throw new ApiError({
    status: response.status,
    title: problem?.title,
    detail: problem?.detail,
    errors: problem?.errors,
  });
}

export function apiRequest(path, options = {}) {
  const requestPath = path.split("?")[0];
  const tracksSession =
    requestPath.startsWith("/api/") &&
    !requestPath.startsWith("/api/public/") &&
    requestPath !== "/api/auth/csrf" &&
    requestPath !== "/api/auth/login";

  return fetch(path, {
    credentials: "same-origin",
    ...options,
  }).then((response) => {
    if (!tracksSession) {
      return parseResponse(response);
    }

    if (response.status !== 401) {
      window.dispatchEvent(new Event(SESSION_ACTIVITY_EVENT));
      return parseResponse(response);
    }

    return parseResponse(response).catch((error) => {
      if (error.title !== "2FA verification failed") {
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
      }
      throw error;
    });
  });
}
